import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { GeoLoadRigOperation } from 'src/features/well-form/entities/geological-load/geo-load-rig-operation.entity';
import { GeologicalLoad } from 'src/features/well-form/entities/geological-load/geological-load.entity';
import { GeologicalLoadViewModel } from 'src/features/well-form/geological-load-tab/geological-load-view-model';

import { GraphRigOperation } from '../../entities/tab-with-stages-entities/rig-operation.entity';

import { GeologicalLoadItem } from './geological-load-item';

import styles from './geological-load-tab.module.scss';

type Props = {
  geoTaskGeoLoad: GeologicalLoad | null;
  rigOperations: GraphRigOperation[];
  geologicalLoadViewModel: GeologicalLoadViewModel;
  geoLoadRigOperations: GeoLoadRigOperation[];
};

export const GeologicalLoadTab = observer<Props>(function GeologicalLoadTab({
  geoTaskGeoLoad,
  rigOperations,
  geoLoadRigOperations,
  geologicalLoadViewModel,
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      {!geoLoadRigOperations.length && geoTaskGeoLoad && (
        <GeologicalLoadItem geoLoad={geoTaskGeoLoad} geologicalLoadViewModel={geologicalLoadViewModel} />
      )}
      {geoLoadRigOperations.map((glro) => {
        const rigOperation = rigOperations.find((ro) => ro.entityId === glro.rigOperationEntityId);

        if (!rigOperation) {
          console.error('cannot find corresponding rigOperation for geoLoadRigOperaion', glro);
          return null;
        }

        return (
          <div key={glro.entityId}>
            <div className={styles.rigOperationHeader}>
              <p className={styles.rigOperationTitle}>Подход № {rigOperation.index + 1}</p>
            </div>

            {!glro.stages.length && (
              <GeologicalLoadItem geoLoad={glro.geologicalLoad} geologicalLoadViewModel={geologicalLoadViewModel} />
            )}

            {glro.stages.map((glStage) => {
              const stage = rigOperation.stages.find((stage) => glStage.stageEntityId === stage.entityId);

              if (!stage) {
                console.error('cannot find corresponding stage', glStage);
                return null;
              }

              return (
                <div key={glStage.entityId}>
                  {!glStage.sections.length && (
                    <div className={styles.stageGeoLoadWrapper}>
                      <GeologicalLoadItem
                        geoLoad={glStage.geologicalLoad}
                        geologicalLoadViewModel={geologicalLoadViewModel}
                      />
                    </div>
                  )}

                  {glStage.sections.map((glSection) => {
                    const section = stage.sections.find((section) => section.entityId === glSection.sectionEntityId);

                    if (!section) {
                      console.error('cannot find corresponding section', glSection);
                      return null;
                    }

                    const sectionType = geologicalLoadViewModel.getSectionTypeFn(section) ?? 'Нераспознанная секция';

                    return (
                      <div key={glSection.entityId} className={styles.sectionWrapper}>
                        <div className={styles.sectionHeader}>
                          <p className={styles.sectionTitle}>{t(sectionType)}</p>
                        </div>
                        <div className={styles.sectionGeoLoadWrapper}>
                          <GeologicalLoadItem
                            geoLoad={glSection.geologicalLoad}
                            geologicalLoadViewModel={geologicalLoadViewModel}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
});
